/* eslint-disable camelcase */
import { fetchData } from '../utils';
import { ApiResponse } from '../types';

export const CONFIG_KEY = 'config';

export interface ExchangeRate {
  name: string;
  value: number;
}

export const getExchangeRate = async () => {
  return fetchData<
    ApiResponse<{
      exchangeRates: ExchangeRate[];
    }>
  >(`/${CONFIG_KEY}`);
};
